export type NavLeaf = { label: string; href: string };

export type NavGroup = { label: string; children: NavLeaf[] };

export type NavChild = NavLeaf | NavGroup;

export type NavLinkItem = {
  label: string;
  href?: string;
  children?: NavChild[];
};

const MATERIALES: NavChild[] = [
  { label: "Audiolibros", href: "/materiales/audiolibros" },
  { label: "Videos", href: "/videos" },
  { label: "Señales de tránsito", href: "/senales" },
  { label: "Normativa de tránsito", href: "/normativa" },
  {
    label: "Clase B — Automóvil",
    children: [
      { label: "Guía de la licencia", href: "/licencia-clase-b" },
      { label: "Resumen del libro (índice)", href: "/materiales/libro-clase-b-resumen" },
      { label: "Audiolibro", href: "/materiales/audiolibros/clase-b" },
      { label: "Puntos clave del examen", href: "/materiales/clase-b" },
      { label: "Examen práctico", href: "/examen-practico-clase-b" },
      { label: "Libro del conductor", href: "/materiales/libro-clase-b" },
    ],
  },
  {
    label: "Clase C — Motocicleta",
    children: [
      { label: "Guía de la licencia", href: "/licencia-clase-c" },
      { label: "Resumen del libro (índice)", href: "/materiales/libro-clase-c-resumen" },
      { label: "Audiolibro", href: "/materiales/audiolibros/clase-c" },
      { label: "Puntos clave del examen", href: "/materiales/clase-c" },
      { label: "Libro del conductor", href: "/materiales/libro-clase-c" },
    ],
  },
  {
    label: "Clase CR — Triciclo de carga",
    children: [
      { label: "Guía de la licencia", href: "/licencia-clase-cr" },
      { label: "Cuestionario oficial", href: "/materiales/cuestionario-clase-c-restringida" },
    ],
  },
  {
    label: "Profesionales (A1–A5)",
    children: [
      { label: "Clase A1 — Taxis", href: "/licencia-clase-a1" },
      { label: "Clase A2 — Buses y ambulancias", href: "/licencia-clase-a2" },
      { label: "Clase A3 — Buses sin límite", href: "/licencia-clase-a3" },
      { label: "Clase A4 — Camiones rígidos", href: "/licencia-clase-a4" },
      { label: "Clase A5 — Tractocamiones", href: "/licencia-clase-a5" },
      { label: "Resumen del libro (índice)", href: "/materiales/libro-conductor-profesional-resumen" },
      { label: "Audiolibro", href: "/materiales/audiolibros/profesional" },
      { label: "Libro del conductor profesional", href: "/materiales/libro-conductor-profesional" },
    ],
  },
  {
    label: "Licencias antiguas (A1* y A2*)",
    children: [
      { label: "Clase A1* / A2* — Antiguas", href: "/licencia-clase-a1-a2" },
      { label: "A1 antigua", href: "/licencia-a1-antigua" },
      { label: "A2 antigua (camiones)", href: "/licencia-a2-antigua" },
      { label: "Cuestionario A1*, A2*, D y E", href: "/materiales/cuestionario-clase-a1-a2-d-e" },
    ],
  },
  {
    label: "Especiales (D y E)",
    children: [
      { label: "Clase D — Maquinaria automotriz", href: "/licencia-clase-d" },
      { label: "Clase E — Tracción animal", href: "/licencia-clase-e" },
    ],
  },
  { label: "DS 96/2018 — Normas vigentes", href: "/materiales/ds-96-2018" },
];

// Ayuda generales y de ayuda (orientación, no material de estudio por clase).
const AYUDA: NavChild[] = [
  { label: "Cómo funciona", href: "/como-funciona" },
  { label: "Preguntas frecuentes", href: "/materiales/faq" },
  { label: "Cómo obtener tu licencia", href: "/obtener-licencia" },
  // Trámites: lista plana; un grupo aquí abriría su flyout fuera de pantalla (Ayuda está a la derecha).
  { label: "Sacar hora por comuna", href: "/licencia-de-conducir" },
  { label: "Escuelas de conductores", href: "/escuelas-de-conductores" },
  { label: "Renovar licencia", href: "/renovar-licencia-de-conducir" },
  { label: "Renovar licencia profesional", href: "/renovar-licencia-profesional" },
  { label: "Examen psicotécnico", href: "/examen-psicotecnico" },
  { label: "Examen práctico clase B", href: "/examen-practico-clase-b" },
  { label: "Licencias para extranjeros", href: "/materiales/extranjeros" },
  { label: "Tips para ciclistas", href: "/materiales/ciclistas" },
];

export const AUTH_NAV_LINKS: NavLinkItem[] = [
  { label: "Inicio", href: "/inicio" },
  { label: "Practicar", href: "/practicar" },
  { label: "Progreso", href: "/progreso" },
  { label: "Material de estudio", children: MATERIALES },
  { label: "Ayuda", children: AYUDA },
  { label: "Planes", href: "/planes" },
  { label: "Contacto", href: "/contacto" },
];

export const PUBLIC_NAV_LINKS: NavLinkItem[] = [
  { label: "Inicio", href: "/" },
  { label: "Test gratis", href: "/test-gratis" },
  { label: "Material de estudio", children: MATERIALES },
  { label: "Ayuda", children: AYUDA },
  { label: "Planes", href: "/planes" },
  { label: "Contacto", href: "/contacto" },
];

// Menú de administración, agrupado en submenús por área.
// Un item con `href` es un enlace suelto; un item con `children` es una sección.
export const ADMIN_NAV: NavChild[] = [
  { label: "Dashboard", href: "/admin/dashboard" },
  {
    label: "Contenido",
    children: [
      { label: "Preguntas", href: "/admin/preguntas" },
      { label: "Categorías", href: "/admin/categorias" },
      { label: "Etiquetas", href: "/admin/etiquetas" },
      { label: "Imágenes", href: "/admin/imagenes" },
      { label: "Tipos de test", href: "/admin/tipos-test" },
    ],
  },
  {
    label: "Usuarios",
    children: [
      { label: "Usuarios", href: "/admin/usuarios" },
      { label: "Invitados", href: "/admin/invitados" },
      { label: "Historial de login", href: "/admin/login-historial" },
      { label: "Conexiones con IA", href: "/admin/conexiones-ia" },
      { label: "Tests ejecutados", href: "/admin/tests" },
      { label: "Preguntas respondidas", href: "/admin/preguntas-respondidas" },
      { label: "Estadísticas de preguntas", href: "/admin/estadisticas-preguntas" },
      { label: "Estadísticas por usuario", href: "/admin/estadisticas-preguntas-usuario" },
      { label: "Estadísticas de tests", href: "/admin/estadisticas-tests" },
      { label: "Probabilidad de aprobar", href: "/admin/probabilidad-usuarios" },
    ],
  },
  {
    label: "Ventas",
    children: [
      { label: "Pagos", href: "/admin/pagos" },
      { label: "Garantías", href: "/admin/garantias" },
      { label: "Planes", href: "/admin/planes" },
      { label: "Cupones", href: "/admin/cupones" },
      { label: "Invitaciones de referidos", href: "/admin/referidos" },
      { label: "Municipios", href: "/admin/municipios" },
    ],
  },
  {
    label: "Notificaciones",
    children: [
      { label: "Notificaciones", href: "/admin/notificacion" },
      { label: "Tipos de notificación", href: "/admin/tipo-notificacion" },
    ],
  },
];
